import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateObject } from "react-multi-date-picker";
import {
  SalePaymentMethod_Enum,
  TransportType_Enum,
  TripOptionType_Enum,
} from "services/sale/common/enums";
import {
  GetTripPrices_Response_Data_VehicleCategory,
  Point,
  StopMinutesItem,
  TripOption,
} from "services/sale/common/types";
import {
  NearbyVehicles_Response_Data,
  SaleApi_Point,
} from "services/sale/map/types";
import {
  CarCategoryModel,
  GetTripPrices_Response_Data_BusinessPrice,
  VehicleUserType,
} from "services/sale/marketPlace/types";
import {
  FavoriteLocation,
  OtherPassengerInfo_Model,
} from "services/sale/passenger/types";
import { RequestStep_Enum, SortType_Enum } from "../types/enums";
import { FavoriteLocation_Enum } from "../types/enums";
export interface RequestModel {
  unitId?: number;
  //دسته بندی
  vehicleCategoryId?: number;
  //نوع خودرو
  vehicleUserTypeId?: number;
  // بیزنس
  vehicleBusinessId?: number;
  // نوع خودرو
  vehicleUserTypeCaption?: string;
  //توضیحات مدل هر بیزنس
  vehicleModelsDescription?: string;
  // ظرفیت خودرو
  capacity?: number;
  // ظرفیت چمدان
  baggageCapacity?: number;
  // قیمت سفر
  tripPrice?: number;
  cacheId?: string;
  kilometer: number;
  durationTime: number;
  GetConsoleSettingSuccess?: boolean;
  mapCenterLocation?: Point;
  // برون شهری است یا نه
  isOutCityTrip?: boolean;
  // روش پرداخت فعلی انتخاب شده
  tempPaymentMethod?: SalePaymentMethod_Enum;
  // روش پرداخت قطعی انتخاب شده پس از تایید روش پرداخت در مرحله انتخاب نوع و دسته بندی خودرو
  PaymentMethod: SalePaymentMethod_Enum;
  salePaymentMethods: SalePaymentMethod_Enum[];
  options: Array<TripOption>;
  // گزینه های سفر موقت
  tempOptions: Array<TripOption>;
  stopMinutesItems: Array<StopMinutesItem>;
  baggageTransportaionOption: TripOption | null;
  extraBaggageOption: TripOption | null;
  stopMinuteOption: TripOption | null;
  extraDestinationOptions: TripOption[] | null;

  // مقصد اضافی ویرایش شده
  editExtraDestination: TripOption | null;

  tripPriceLoading: boolean;
  tripPriceSuccess: boolean;
  callTripPrice: boolean;
  callGetCarCategory: boolean;
  disableByVehicleType: boolean;
  optionsCount: number;
  optionPrice: number;
  currentExtraDest: number;
  step: RequestStep_Enum;
  multiBusiness: boolean;

  // لودینگ انتخاب مبدا یا مقصد
  selectLocationLoading?: boolean;

  // اطلاعات مبدا
  sourcePoint?: Point;
  sourceAddress?: string;
  sourceArea?: string;
  sourceLocations: Array<SaleApi_Point>;
  // مشخص کردن اینکه مبدا از چه نوعی می باشد
  sourceType?: TransportType_Enum;
  PickupLocationId: number;
  showSourceOnMap: boolean;

  // اطلاعات مقصد
  destinationPoint?: Point;
  destinationAddress?: string;
  destinationArea?: string;
  destinationType?: TransportType_Enum;
  destinationLocations: Array<SaleApi_Point>;
  dropOffLocationId: number;
  showDestinationOnMap: boolean;
  defaultActiveLocation: number;
  // اطلاعات مارکر معلق بر روی نقشه
  tempMarker: Point;
  tempAddress?: string;
  tempPoint?: Point;
  tempArea?: string;
  tempSourceType?: TransportType_Enum;
  // نقاط سوار شدن یا پیاده شدن
  tempLocations: Array<SaleApi_Point>;
  tempLocationId?: number;
  tripId?: number;
  categories: Array<CarCategoryModel>;
  businessesVehicleUserTypes: Array<VehicleUserType>;
  vehicleCategory: GetTripPrices_Response_Data_VehicleCategory;
  vehicleBusinesses: Array<GetTripPrices_Response_Data_BusinessPrice>;
  dispatchTerminated?: boolean;
  nearbyVehicles?: NearbyVehicles_Response_Data[];
  showNearbyVehicles: boolean;
  routePoints?: Point[];
  routeOverview?: string;
  routeKm?: number;
  currentLocation?: Point | null;

  // تنظیمات مربوط به زمان رزرو
  maxReserveTripDay?: number;
  minReserveTripTime?: number;
  reserveTimeFA?: DateObject;
  reserveTimeFaApi?: string;

  // تنظیمات مکان منتخب
  favoritePoint?: Point;
  favoriteAddress?: string;
  favoriteLocation: FavoriteLocation_Enum;
  favoriteLocationList: FavoriteLocation[];
  favoriteLocationToggleUpdate: boolean;
  favoriteSelectedId?: number;

  // تنظیمات مربوط به سفر برای دیگری
  forOtherTrip?: boolean;
  otherPassengerInfo?: OtherPassengerInfo_Model;
  passengerNationalNumbers?: string[];

  // اطلاعات کاربر مربوط به پیکاپ
  pickUpUserInfoModel: updatePickUpUserInfoModel;
  isPickup?: boolean;
}
interface updateCategoriesModel {
  vehicleCategoryId: number;
  vehicleUserTypeId: number;
  capacity?: number;
  isPickup?: boolean;
  baggageCapacity?: number;
  vehicleUserTypeCaption?: string;
}
interface updateBusinessesModel {
  vehicleBusinessId: number;
  vehicleUserTypeId: number;
  capacity?: number;
  isPickup?: boolean;
  baggageCapacity?: number;
  vehicleUserTypeCaption?: string;
  cacheId?: string;
}

interface updatePickUpUserInfoModel {
  fullName: string;
  phoneNumber: string;
  transportationNumber: string;
}

const RequestSlice = createSlice({
  name: "RequestSlice",
  initialState: {} as RequestModel,
  reducers: {
    //_______________________________
    //اپدیت داده ها
    updateData: (state, action) => {
      state = {
        ...state,
        ...action.payload,
      };
      return state;
    },
    //_______________________________
    // update toggle favorite location
    toggleFavoriteLocation: (state, action) => {
      state = {
        ...state,
        favoriteLocationToggleUpdate: !state.favoriteLocationToggleUpdate,
      };
      return state;
    },

    //_______________________________
    cleareData: (state, action) => {
      state = {} as RequestModel;
      return state;
    },

    //_______________________________
    // آپدیت دسته بندی خودرها
    updateCategories: (state, action: PayloadAction<updateCategoriesModel>) => {
      state.categories?.forEach((item) => {
        if (action.payload.vehicleCategoryId === item.id) {
          item.isSelected = true;
          item.vehicleUserTypes.forEach((vehicle) => {
            if (vehicle.id === action.payload.vehicleUserTypeId) {
              vehicle.isSelected = true;
            } else {
              vehicle.isSelected = false;
            }
          });
        } else {
          item.isSelected = false;
        }
      });

      state.vehicleCategoryId = action.payload.vehicleCategoryId;
      state.vehicleUserTypeId = action.payload.vehicleUserTypeId;
      state.isPickup = action.payload.isPickup;
      state.capacity = action.payload.capacity;
      state.baggageCapacity = action.payload.baggageCapacity;
      state.vehicleUserTypeCaption = action.payload.vehicleUserTypeCaption;

      return state;
    },
    //_______________________________
    // آپدیت نوع بیزنس خودرها
    updateBusinessesModel: (
      state,
      action: PayloadAction<updateBusinessesModel>
    ) => {
      state.businessesVehicleUserTypes?.forEach((item) => {
        if (action.payload.vehicleUserTypeId === item.id) {
          item.isSelected = true;
          item.businesses.forEach((vehicle) => {
            if (vehicle.id === action.payload.vehicleBusinessId) {
              vehicle.isSelected = true;
            } else {
              vehicle.isSelected = false;
            }
          });
        } else {
          item.isSelected = false;
        }
      });

      state.vehicleUserTypeId = action.payload.vehicleUserTypeId;
      state.vehicleBusinessId = action.payload.vehicleBusinessId;
      state.capacity = action.payload.capacity;
      state.isPickup = action.payload.isPickup;
      state.baggageCapacity = action.payload.baggageCapacity;
      state.vehicleUserTypeCaption = action.payload.vehicleUserTypeCaption;
      state.cacheId = action.payload.cacheId;

      return state;
    },

    //_______________________________
    // مرتب سازی بیزنس ها بر اساس قیمت نزولی یا صعودی
    sortBusinesses: (state, action: PayloadAction<SortType_Enum>) => {
      switch (action.payload) {
        case SortType_Enum.Ascending:
          state.businessesVehicleUserTypes?.forEach((item) => {
            item.businesses.sort((a, b) => {
              if (
                a.newPrice !== undefined &&
                b.newPrice !== undefined &&
                a.newPrice !== b.newPrice
              )
                return (a.newPrice || 0) - (b.newPrice || 0);
              else return 0;
            });
          });
          return state;

        case SortType_Enum.Descending:
          state.businessesVehicleUserTypes?.forEach((item) => {
            item.businesses.sort((a, b) => {
              if (a.newPrice !== b.newPrice)
                return (b.newPrice || 0) - (a.newPrice || 0);
              else return 0;
            });
          });
          return state;

        default:
          return state;
      }
    },
    //_______________________________
    // آپدیت قیمت دسته بندی خودروها
    updatePriceCategories: (
      state,
      action: PayloadAction<GetTripPrices_Response_Data_VehicleCategory>
    ) => {
      state.categories?.forEach((item) => {
        item.vehicleUserTypes.forEach((vehicle) => {
          if (action.payload.id === item.id) {
            var vehicleTemp = action.payload.vehicleUserTypes.find(
              (y) => y.id === vehicle.id
            );
            vehicle.newPrice = vehicleTemp ? vehicleTemp?.newPrice! : -1;
            vehicle.originPrice = vehicleTemp ? vehicleTemp?.originPrice! : -1;
          }
        });
      });

      return state;
    },
    //_______________________________
    // آپدیت قیمت  نوع خودروها
    updatePriceVehicleUserType: (
      state,
      action: PayloadAction<Array<GetTripPrices_Response_Data_BusinessPrice>>
    ) => {
      state.businessesVehicleUserTypes?.forEach((item) => {
        item.businesses.forEach((vehicle) => {
          if (state.vehicleUserTypeId === item.id) {
            var vehicleTemp = action.payload.find(
              (y) => y.businessId === vehicle.id
            );
            vehicle.newPrice = vehicleTemp ? vehicleTemp?.newPrice! : -1;
            vehicle.originPrice = vehicleTemp ? vehicleTemp?.originPrice! : -1;
            vehicle.cacheId = vehicleTemp ? vehicleTemp?.cacheId! : "";
          }
        });
      });

      return state;
    },
    //_______________________________
    // اضافه کردن مقصد اضافی
    addOrEditExtraDestination: (state, action: PayloadAction<boolean>) => {
      var dest: TripOption = {
        id: 0,
        type: TripOptionType_Enum.ExtraDestination,
        value: null,
        pendingValue: null,
        price: null,
        pointInfo: {
          point: state.tempPoint!,
          address: state.tempAddress!,
          priority:
            action.payload === true
              ? state.editExtraDestination?.pointInfo?.priority!
              : state.currentExtraDest!,
          dropOffLocationId: state.tempArea ? state.tempLocationId : undefined,
        },
        status: null,
      };

      // -----تغییرات در گزینه مقاصد اضافی------
      // حذف مقصد قبلی در صورت ویرایش
      state.extraDestinationOptions = state.extraDestinationOptions?.filter(
        (x) =>
          x.pointInfo?.priority !==
          state.editExtraDestination?.pointInfo?.priority
      )!;

      // اضافه کردن مقصد جدید
      state.extraDestinationOptions?.push(dest);

      // مرتب سازی مقاصد اضافی بر اساس اولویت
      state.extraDestinationOptions?.sort((a, b) =>
        a.pointInfo?.priority! > b.pointInfo?.priority! ? 1 : -1
      );

      // -----تغییرات در گزینه سفر موقت ------
      // ویرایش مقصد اضافی
      if (action.payload === true) {
        state.tempOptions = state.tempOptions.map((item) => {
          if (
            item.pointInfo?.priority ===
            state.editExtraDestination?.pointInfo?.priority!
          ) {
            return dest;
          } else {
            // No changes
            return item;
          }
        });

        // ریست کردن مقصد اضافی ویرایش شده
        state.editExtraDestination = null;
      } else {
        // اضافه کردن مقصد جدید در گزینه های سفر موقت
        if (!state.tempOptions) {
          state.tempOptions = [dest];
        } else {
          state.tempOptions?.push(dest);
        }
      }

      return state;
    },

    //_______________________________
    // حذف مقصد اضافی
    prioritizeExtraDestination: (state, action: PayloadAction<number>) => {
      // کاهش تعداد مقاصد اضافی
      state.currentExtraDest = state.currentExtraDest - 1;

      var tempExtra = state.extraDestinationOptions!;
      // حذف مقصد مورد نظر
      if (tempExtra) {
        tempExtra = tempExtra!.filter(
          (x) => x.pointInfo?.priority !== action.payload
        );

        // اولویت بندی دوباره مقاصد
        tempExtra?.forEach((item, inx) => {
          item.pointInfo = { ...item.pointInfo!, priority: inx + 1 };
        });
      }

      // آپدیت گزینه های سفر موقت
      state.tempOptions = state.tempOptions
        .filter((x) => x.type !== TripOptionType_Enum.ExtraDestination)
        .concat(tempExtra!);
      state.extraDestinationOptions = tempExtra;
      return state;
    },

    updatePickUpUserInfo: (
      state,
      action: PayloadAction<updatePickUpUserInfoModel>
    ) => {
      state.pickUpUserInfoModel = action.payload;

      return state;
    },
  },
});

export default RequestSlice;
